<ion-modal [isOpen]="isOpen" (didDismiss)="closeModal.emit()" class="card-popup">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Email Preview</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="closeModal.emit()">
            <ion-icon name="close"></ion-icon>
            Close
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <app-preview-email
        [includePhotosInEmail]="includePhotosInEmail"
        [hasExpeditingEmail]="hasExpeditingEmail"
        (togglePhotosInEmail)="onTogglePhotosInEmail($event)">
      </app-preview-email>
    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="onPopoutEmail()" [disabled]="photosLoading">
            <div class="button-content">
              <ion-icon name="open" slot="start" *ngIf="!photosLoading"></ion-icon>
              <ion-spinner *ngIf="photosLoading" name="crescent"></ion-spinner>
              <span *ngIf="!photosLoading">Popout Email</span>
            </div>
          </ion-button>
          <ion-button (click)="sendEmail.emit()" [disabled]="isLoading">
            <ion-icon name="send" slot="start"></ion-icon>
           &nbsp; Send Email
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal> 